<template>
    <div class="layout">
        <form :class="{formExpanded}" v-if="formCreated">
            <h4>Destination:</h4>
            <NiceInput @input="newLinkDestination = $event" no-suggestions placeholder="example.com" type="text"/>
            <br>
            <h4>Shorted link:</h4>

            <EndLinkInput :constant-value="baseShareLink" :default-value="newLinkId" v-model="newLinkId"/>
            <br>

            <div>
                <NiceButton @click="formExpanded = false" icon="cancel" secondary title="Cancel"/>
                <NiceButton @click="create" icon="add" title="Create"/>
            </div>
        </form>

        <div @click="addNewClicked" class="form-parent-layout file">
            <Icon name="add"/>
            <span class="name">Make another link shorter</span>
        </div>

        <div class="list" v-if="links">
            <div :class="{pending: item.pending}" :key="item.id" class="file" v-for="item in links">
                <Icon name="link"/>
                <span class="name">{{item.id}}</span>
                <a :href="item.url" class="url" referrerpolicy="no-referrer" rel="noopener"
                   target="_blank">{{item.url}}</a>
                <!--                <span>{{item.created && item.created.toDate().toLocaleDateString() || ''}}</span>-->
                <div class="right-icons">
                    <Icon @click.native="shareLink(item)" name="share" v-if="shareAvailable"/>
                    <Icon @click.native="copyLink(item)" name="content_copy"/>
                    <Icon @click.native="deleteLink(item)" name="remove_circle_outline" title="Delete this link"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as firebase from 'firebase/app';
    import 'firebase/firestore';
    import {requireUser} from '../other/page-global';
    import Icon from '../components/Icon';
    import NiceInput from '../components/NiceInput';
    import NiceButton from '../components/NiceButton';
    import EndLinkInput from '../components/EndLinkInput';

    export default {
        name: 'ShortedLinksList',
        components: {EndLinkInput, NiceButton, NiceInput, Icon},
        methods: {
            addNewClicked() {
                this.formCreated = true;
                this.formExpanded = !this.formExpanded;
            },
            shareLink(link) {
                navigator.share({
                    title: 'Link for you',
                    url: this.baseShareLink + link.id
                });
            },
            copyLink(link) {
                navigator.clipboard
                         .writeText(this.baseShareLink + link.id)
                         .catch(e => alert(e.message));
            },
            async deleteLink(link) {
                try {
                    await this.firestore
                              .collection('links')
                              .doc(link.id)
                              .delete();
                } catch (e) {
                    alert(e.message);
                }
            },
            async create() {
                const id = this.newLinkId;
                if (typeof id !== 'string' || id.length < 1 || id.length > 20) {
                    alert('Link name length must be between 1 and 20');
                    return;
                }
                if (id.includes('/')) {
                    alert('Link name must not contain slash characters');
                    return;
                }
                const destination = this.newLinkDestination;
                if (typeof destination !== 'string' || !/https?:\/\/.*/.test(destination)) {
                    alert('Destination must be a http or https link');
                    return;
                }

                if (this.links && this.links.find(e => e.id === id)) {
                    alert('Link with this name already points to other destination');
                    return;
                }
                this.formExpanded = false;

                try {
                    await this
                        .firestore
                        .collection('links')
                        .doc(id.toLocaleLowerCase())
                        .set({
                            url: destination,
                            uid: this.uid,
                            created: firebase.firestore.FieldValue.serverTimestamp()
                        });
                } catch (e) {
                    if (e.code === 'permission-denied') {
                        alert('This name is already used');
                        return;
                    }
                    console.error(e);
                    alert(e.message);
                }

            },
            onLinksSnapshot(snap) {
                this.links = snap.docs.map(e => ({
                    ...e.data(),
                    pending: e.metadata.hasPendingWrites,
                    id: e.id
                }));
            }
        },
        created() {
            requireUser(this).then(({uid}) => {
                this.uid = uid;
                this.unsub = this
                    .firestore
                    .collection('links')
                    .where('uid', '==', uid)
                    .orderBy('created', 'desc')
                    .onSnapshot(this.onLinksSnapshot);
            });
        },
        destroyed() {
            if (this.unsub)
                this.unsub();
        },
        data() {
            return {
                firestore: firebase.firestore(),
                links: null,
                newLinkDestination: null,
                newLinkId: null,
                formCreated: false,
                formExpanded: false,
                baseShareLink: 'https://shrink.web.app/',
                shareAvailable: navigator.share
            };
        }
    };
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
    .layout {
        position: relative;
    }


    form {
        z-index: 30;
        box-shadow: 2px 0 6px 0 rgba(0, 0, 0, .7);
        left: 8px;
        top: 8px;
        border-radius: 8px;
        padding: 8px;
        position: absolute;
        animation: FadeIn .3s;
        pointer-events: none;
        opacity: 0;
        background-color: #092e4e;
        transition: opacity .3s;
    }

    .formExpanded {
        pointer-events: unset;
        opacity: 1;
        display: block;
    }

    .list {
        animation: FadeIn .3s;
    }

    .file {
        display: grid;
        grid-template-areas: 'icon name name right' 'icon url . right';
        grid-template-columns: 50px auto 1fr auto;
        align-items: center;
        justify-content: center;
        padding: 12px;
        text-align: left;
        transition: background-color .3s, opacity .3s;
    }

    .form-parent-layout {
        cursor: pointer;
        grid-template-areas: 'icon name .';
    }

    .form-parent-layout .name {
        font-size: 1.1em;
        font-weight: 600;
    }

    .file:hover {
        background-color: #ffffff11;
    }

    .file > .icon {
        padding-right: 12px;
        font-size: 32px;
        justify-self: center;
    }

    .url {
        overflow: hidden;
        text-overflow: ellipsis;
        grid-area: url;
        opacity: .7;
        font-size: .9em;
        color: white;
        text-decoration: none;
    }

    .url:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .name {
        grid-area: name;
    }

    .pending {
        opacity: .5;
    }

    @media (prefers-reduced-motion: no-preference) {
        @keyframes PendingFrames {
            from {
                opacity: .7;
            }
            to {
                opacity: .3;
            }
        }

        .pending {
            animation: PendingFrames 2s alternate infinite ease-in-out;
        }
    }

    .right-icons {
        display: flex;
        flex-direction: row;
        cursor: pointer;
        grid-area: right;
        opacity: .8;
        font-size: 14px;
    }

    .right-icons > * {
        padding: 4px;
    }

    h4 {
        margin: 4px;
    }

    @media screen and (pointer: fine) {
        .right-icons {
            /*opacity: 0;*/
            transition: opacity .2s;
        }

        .file:hover .right-icons {
            opacity: .8;
        }
    }

    @media screen and (max-width: 400px) {
        .formExpanded {
            width: calc(100vw - 32px);
        }

    }

</style>
